
import { defineComponent } from 'vue';
import Button from '@/components/atoms/Button.vue';
import { mapGetters } from 'vuex';
import { RegistrationRequestPanelUtils } from '@/model/clientConfig';

export default defineComponent({
  name: 'RegistrationPanel',
  components: {
    Button
  },
  emits: ['registration-request'],
  methods: {
    switchToRegistration () {
      this.$router.push({
        path: '/registration',
        query: {
          ...this.$route.query
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'registrationRequestPanelMessages',
      'registrationRequestPanelUtils'
    ]),
    panelBackgroundColor () {
      const utils = (this as unknown as {
        registrationRequestPanelUtils?: RegistrationRequestPanelUtils
      }).registrationRequestPanelUtils;

      return utils?.registrationBackground || '#E5EFF699';
    }
  }
});
